import { render, staticRenderFns } from "./Profileview.vue?vue&type=template&id=5d977492&"
import script from "./Profileview.vue?vue&type=script&lang=js&"
export * from "./Profileview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports